import {StateOta} from './app.state-ota';
import {OtaActionType} from './app.actions-ota';
const initialState: StateOta = {
    nbOtaAdded: 0,
    nbCombineAdded: 0,
    type: '',
    response: null,
};

export function reducer(state: StateOta = initialState, action) {

    switch (action.type) {
//        case '[OTA] add.new':
        case OtaActionType.AddNew:
            return {
                ...state, type: action.type, response: action.payload, nbOtaAdded: state.nbOtaAdded + 1
            };
        case OtaActionType.AddCombine:
//        case '[OTA] add.combine':
            return {
                ...state, type: action.type, response: action.payload, nbCombineAdded: state.nbCombineAdded + 1
            };
        default:
            return state;
    }
}